import { render, staticRenderFns } from "./ApplicationFieldCollectionHeading.vue?vue&type=template&id=71fb7193&scoped=true&"
import script from "./ApplicationFieldCollectionHeading.vue?vue&type=script&lang=js&"
export * from "./ApplicationFieldCollectionHeading.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFieldCollectionHeading.vue?vue&type=style&index=0&id=71fb7193&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb7193",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
